import { Injectable } from '@angular/core';
import { Media, StrapiMediaAttributes } from '@core/const';

@Injectable({ providedIn: 'root' })
export class StrapiMediaNormalizer {
  convert(media: StrapiMediaAttributes, strapiBaseUrl: string): Media {
    const mediaUrl = media.url.startsWith('http') ? media.url : `${strapiBaseUrl}${media.url}`;

    return {
      name: media.name,
      altText: media.alternativeText || '',
      ext: media.ext,
      mime: media.mime,
      size: media.size,
      url: mediaUrl,
    };
  }
}
